import {Component, HostListener, Input, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

  @Input() includeNameAndMenu: boolean;
  displayName: string;
  showExpandMenu = false;
  showSyncWithSpotify = false;

  constructor(private http: HttpClient, public router: Router,private service: SpotifyTagsService) { }

  ngOnInit() {
    this.service.isAuthenticated().subscribe(res => {
      this.displayName = res.principal.attributes.display_name ? res.principal.attributes.display_name : res.principal.attributes.email;
    });
  }

  logout() {
    this.http.post('logout', {}).pipe(finalize(() => this.router.navigateByUrl('signup'))).subscribe();
  }

  goToHome() {
    this.service.navigate();
    this.router.navigateByUrl('/artists');
  }

  toggleShowExpandMenu() {
    event.stopPropagation();
    this.showExpandMenu = !this.showExpandMenu;
  }

  @HostListener('click')
  hideExpandMenuAgain() {
    this.showExpandMenu = false;
  }

  @HostListener('document:click')
  hideExpandMenu() {
    this.showExpandMenu = false;
  }

  toggleSynchroniseModal() {
    this.showSyncWithSpotify = !this.showSyncWithSpotify;
  }

  synchronise() {
    this.showExpandMenu = false;
    this.showSyncWithSpotify = false;
    this.service.navigate();
    this.router.navigateByUrl('/?sync=true');
  }
}
